import { ParameterType } from '@/study-search/enums';
import Logger from '@/search-page/platform/Logger';
import { ParsedFilter } from '../../models/generalizations/ParsedFilter';
import { AutocompleteInterface } from '../../interfaces/autocomplete.interface';
import { AutocompleteSelection } from '@/study-search/autocomplete/AutocompleteSelection';
import store from '..';

export class AutocompletePlugin {
	public initiate(): void {
		this.addAutocompleteListener();
	}

	private addAutocompleteListener(): void {
		document.addEventListener('auto_complete_suggested', ((event: CustomEvent) => {
			this.processEvent(event.detail as AutocompleteInterface);
		}) as EventListener);
	}

	private processEvent(autocomplete: AutocompleteInterface): void {
		if (!autocomplete) {
			this.throwError();

			return;
		}

		const filters = this.getFilters(autocomplete);

		this.processAutocompleteInput(filters);
	}

	private getFilters(autocomplete: AutocompleteInterface): ParsedFilter[] {
		const autocompleteSelection = this.processAutocompleteSelection(autocomplete);
		return autocompleteSelection.map((selection) => selection.process()).flat();
	}

	private processAutocompleteInput(filters: ParsedFilter[]): void {
		void store.actions.processAutocompleteInput({
			filters
		});
	}

	private processAutocompleteSelection(autocomplete: AutocompleteInterface): AutocompleteSelection[] {
		const autocompleteSelection: AutocompleteSelection[] = [];
		if (autocomplete.keywords.what.trim() !== '') {
			autocompleteSelection.push(this.processAutocompleteForWhatKeyword(autocomplete));
		}
		if (autocomplete.keywords.where.trim() !== '') {
			autocompleteSelection.push(this.processAutocompleteForWhereKeyword(autocomplete));
		}
		return autocompleteSelection;
	}

	private processAutocompleteForWhatKeyword(autocomplete: AutocompleteInterface): AutocompleteSelection {
		if (autocomplete.searchParameters.discipline_ids?.length > 0) {
			return new AutocompleteSelection().forWhat(
				ParameterType.DISCIPLINES,
				autocomplete.searchParameters.discipline_ids[0].toString()
			);
		}

		return new AutocompleteSelection().forWhat(ParameterType.KEYWORD_WHAT, autocomplete.keywords.what);
	}

	private processAutocompleteForWhereKeyword(autocomplete: AutocompleteInterface): AutocompleteSelection {
		if (autocomplete.searchParameters.country_ids?.length > 0) {
			return new AutocompleteSelection().forWhere(
				ParameterType.COUNTRY,
				autocomplete.searchParameters.country_ids[0].toString()
			);
		}

		if (autocomplete.searchParameters.region_ids?.length > 0) {
			return new AutocompleteSelection().forWhere(
				ParameterType.CONTINENT,
				autocomplete.searchParameters.region_ids[0].toString()
			);
		}

		if (autocomplete.searchParameters.organisation_ids?.length > 0) {
			return new AutocompleteSelection().forWhere(
				ParameterType.ORGANISATIONS,
				autocomplete.searchParameters.organisation_ids[0].toString()
			);
		}

		return new AutocompleteSelection().forWhere(ParameterType.KEYWORD_WHERE, autocomplete.keywords.where);
	}

	private throwError(): void {
		Logger.logError('Autocomplete event detail is not defined');
	}
}
